var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCerrar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono_cerrar",
    "data-name": "Icono cerrar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght300_GRAD0_opsz40",
    d: "M236.308-722.432l-7.469,7.468a.873.873,0,0,1-.623.264.848.848,0,0,1-.637-.264.864.864,0,0,1-.271-.63.864.864,0,0,1,.271-.63l7.468-7.469-7.468-7.469a.873.873,0,0,1-.264-.623.848.848,0,0,1,.264-.637.864.864,0,0,1,.63-.271.864.864,0,0,1,.63.271l7.469,7.469,7.469-7.469a.874.874,0,0,1,.623-.264.848.848,0,0,1,.637.264.864.864,0,0,1,.271.63.864.864,0,0,1-.271.63l-7.468,7.469,7.468,7.469a.873.873,0,0,1,.264.623.848.848,0,0,1-.264.637.864.864,0,0,1-.63.271.864.864,0,0,1-.63-.271Z",
    transform: "translate(-223.309 736.691)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrar);
export default __webpack_public_path__ + "static/media/cerrar.5da5663f337d57b88985c08d3b943752.svg";
export { ForwardRef as ReactComponent };